import { fetchDashboardClient } from 'legacy/apollo/dashboardClient'
import { ApolloError } from 'apollo-client'
import {
  FetchDepartmentsAndAislesProductsInfoMeshDocument,
  type FetchDepartmentsAndAislesProductsInfoMeshQuery,
  type FetchDepartmentsAndAislesProductsInfoMeshQueryVariables,
} from '__codegen__/api'

/**
 * Fetches product information, and returns an object with { [productId]: results }
 *
 * @param variables
 * @returns
 */

export const fetchMeshProductInfo = async (
  variables: FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
) => {
  const client = fetchDashboardClient()

  const result = await client.query<
    FetchDepartmentsAndAislesProductsInfoMeshQuery,
    FetchDepartmentsAndAislesProductsInfoMeshQueryVariables
  >({ query: FetchDepartmentsAndAislesProductsInfoMeshDocument, variables })

  if (result.errors) {
    throw new ApolloError({
      graphQLErrors: result.errors,
      errorMessage: 'Error when fetching products from mesh',
    })
  }

  const data = result.data.catalogToolsApiServiceGetRetailerProductData?.retailerProductData ?? []

  return data.reduce((acc, product) => {
    acc[product.productId] = product

    return acc
  }, {}) as Record<string, (typeof data)[number]>
}
